import {http} from '../utils'

// 查询疲劳值规则
const getFatigueValue = () => {
  const url = `/market/group/fatigueValue/rule`
  return http.post(url)
}

// 更新疲劳值规则
const modifyFatigueValue = params => {
  const url = `/market/group/modify/fatigueValue/rule`
  return http.post(url, params)
}

// 更新项目组特权
const modifyGroupMode = params => {
  const url = `/market/group/modify/groupMode`
  return http.post(url, params)
}

export default {
  getFatigueValue,
  modifyFatigueValue,
  modifyGroupMode
}
